import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Ellipse, Path } from "react-native-svg";

export const IconGlobe2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconGlobe2"><Circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><Ellipse cx="12" cy="12" rx="3.5" ry="9.25" stroke="currentColor" strokeWidth="1.5"/><Path d="M3.5 9.25H20.5" stroke="currentColor" strokeWidth="1.5"/><Path d="M3.5 14.75H20.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconGlobe2;
